import React from 'react';
import { useTranslation } from 'react-i18next';
import './MastersDetailedDescription.css'; 

interface MastersDetailedDescriptionProps {
  photo: string;
  date: string;
  name: string;
  surname: string;
  credentials: string;
  description: string;
  text1: string;
  onBack: () => void;
}

const MastersDetailedDescription: React.FC<MastersDetailedDescriptionProps> = ({ 
  photo, 
  date, 
  name, 
  surname, 
  credentials,  
  description, 
  text1,
  onBack 
}) => {
  const { t } = useTranslation(); // ✅ Import translation function

  return (
    <div className="masters-overview-container"> 
      <div className="masters-overview-image">
        <img src={photo} alt={`${name} ${surname}`} />
      </div>
      <div className="masters-overview-content">
       
        <h1 className="masters-title">{name} {surname}</h1>
        <p className="masters-date">{credentials}</p>
        <p className="masters-description">{description}</p> 

        <h1 className="masters-title">{t('about')}</h1>  {/* ✅ Translated "About" */}
        <p className="masters-description">{text1}</p>  
      </div>
    </div>
  );
};

export default MastersDetailedDescription;
